import React from "react";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import RealTimeTradeAlerts from "../../common/RealTimeTradeAlerts";
import "./style.scss";

const RealTimeTradingAlertsComponent = ({ selectNavigation }) => {
  return (
    <div className="real-time-trading-alerts-component">
      <div
        className="real-time-trading-alerts-navigator"
        onClick={() => selectNavigation("livestream")}
      >
        <ArrowCircleLeftOutlinedIcon /> Main
      </div>

      <div className="real-time-trading-alerts-title">
        Real-Time Trade Alerts on Telegram
      </div>
      <div className="real-time-trading-alerts-guide">
        <strong style={{ color: "#FFFFFF", textDecoration: "underline" }}>
          Platinum Program Telegram Channel
        </strong>{" "}
        is designed to make trading easier for beginners and more lucrative for
        experienced traders. Whether users want to copy an expert trader or
        build and monetize their existing trades. To access the channel, click
        the link below.
      </div>

      <a
        href="https://t.me/+12TAYz7H9nhhMzk5"
        target="_blank"
        rel="noreferrer"
        className="platinum-program-telegram-button"
      >
        Platinum Program Channel
      </a>

      <RealTimeTradeAlerts
        specificGuide="Here are 3 easy steps to setup your Telegram and access to Platinum Program Telegram Channel to receive real-time trade and movement notifications."
        productName="Platinum Program"
        telegramLink="https://t.me/+12TAYz7H9nhhMzk5"
      />
    </div>
  );
};

export default RealTimeTradingAlertsComponent;
